export default __webpack_public_path__ + "static/media/bus-trv-3.f4f99172.png";